// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"108":"2cb608e9","272":"98cde14e","568":"231df96d"}[chunkId] + ".chunk.js";
};